import { AuthTokens, Chat, Feedback, User } from "@/types";

// CONTEXT
export type SupportContextState = {
  feedbackTab: FeedbackTab;
  currentChat?: SupportCurrentChat;
  supportUserAuthTokens?: AuthTokens;
  feedbackFilters: {
    search: string;
  };
};
export type SupportContextAction =
  | {
      readonly type: "SET_FEEDBACK_TAB";
      readonly payload: SupportContextState["feedbackTab"];
    }
  | {
      readonly type: "SET_CURRENT_CHAT";
      readonly payload: SupportCurrentChat;
    }
  | {
      readonly type: "SET_SUPPORT_USER_AUTH_TOKENS";
      readonly payload: AuthTokens;
    }
  | {
      readonly type: "SET_FEEDBACK_FILTERS";
      readonly payload: Partial<SupportContextState["feedbackFilters"]>;
    };

// SECONDARY
export enum FeedbackTab {
  NEW_FEEDBACKS = "NEW_FEEDBACKS",
  IN_PROGRESS = "IN_PROGRESS",
}
export type SupportCurrentChat = {
  id: Chat["id"] | Feedback["id"];
  isActive: boolean;
  participant: User;
  feedback?: Feedback;
};
